import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-lg font-semibold text-[#f5f5f5] mb-4">{title}</h2>
    <div className="text-[#a1a1aa] text-sm leading-relaxed space-y-3">
      {children}
    </div>
  </div>
);

const MentionsLegales = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#09090b]" data-testid="mentions-legales-page">
      <Helmet>
        <title>Mentions l&#233;gales - Cloneia</title>
        <meta name="description" content="Mentions l&#233;gales du site cloneia.fr &#233;dit&#233; par Energosym SA." />
      </Helmet>

      <Header />

      <section className="pt-32 md:pt-40 pb-24 px-6 md:px-12">
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-[#71717a] hover:text-[#3b82f6] text-sm mb-8 transition-colors"
              data-testid="mentions-breadcrumb"
            >
              <ArrowLeft className="w-4 h-4" />
              {"Retour \u00e0 l\u2019accueil"}
            </Link>

            <h1 className="text-3xl sm:text-4xl font-bold text-[#f5f5f5] tracking-tight mb-4" data-testid="mentions-title">
              {"Mentions l\u00e9gales"}
            </h1>
            <p className="text-[#71717a] text-sm mb-12">
              {"Derni\u00e8re mise \u00e0 jour : mars 2026"}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <Section title={"\u00c9diteur du site"}>
              <p>{"Le site cloneia.fr est \u00e9dit\u00e9 par :"}</p>
              <div className="bg-[#0f0f17] border border-white/5 rounded-xl p-5 space-y-1.5">
                <p><span className="text-[#f5f5f5] font-medium">Raison sociale :</span> SA ENERGO SYM</p>
                <p><span className="text-[#f5f5f5] font-medium">Forme juridique :</span> {"Soci\u00e9t\u00e9 Anonyme (SA)"}</p>
                <p><span className="text-[#f5f5f5] font-medium">Capital social :</span> {"10\u00a0000 euros"}</p>
                <p><span className="text-[#f5f5f5] font-medium">{"Si\u00e8ge social :"}</span> {"102, Avenue des Champs-\u00c9lys\u00e9es, 75008 Paris, France"}</p>
                <p><span className="text-[#f5f5f5] font-medium">SIRET :</span> 919 540 435 00014</p>
                <p><span className="text-[#f5f5f5] font-medium">TVA intracommunautaire :</span> FR02919540435</p>
                <p><span className="text-[#f5f5f5] font-medium">{"T\u00e9l\u00e9phone :"}</span> 01 84 80 48 84</p>
                <p><span className="text-[#f5f5f5] font-medium">Courriel :</span> hello@cloneia.fr</p>
              </div>
            </Section>

            <Section title="2. Directeur de la publication">
              <p>{"Le directeur de la publication est Monsieur Srdjan Dimitrijevic, en sa qualit\u00e9 de repr\u00e9sentant l\u00e9gal de la soci\u00e9t\u00e9 SA ENERGO SYM."}</p>
            </Section>

            <Section title={"3. H\u00e9bergeur"}>
              <div className="bg-[#0f0f17] border border-white/5 rounded-xl p-5 space-y-1.5">
                <p><span className="text-[#f5f5f5] font-medium">Nom :</span> OVH SAS</p>
                <p><span className="text-[#f5f5f5] font-medium">{"Si\u00e8ge social :"}</span> 2 rue Kellermann, 59100 Roubaix, France</p>
                <p><span className="text-[#f5f5f5] font-medium">{"T\u00e9l\u00e9phone :"}</span> 1007</p>
                <p><span className="text-[#f5f5f5] font-medium">Site web :</span> <a href="https://www.ovhcloud.com" target="_blank" rel="noopener noreferrer" className="text-[#3b82f6] hover:underline">www.ovhcloud.com</a></p>
              </div>
            </Section>

            <Section title={"4. Propri\u00e9t\u00e9 intellectuelle"}>
              <p>{"L\u2019ensemble du contenu du site cloneia.fr (textes, images, graphismes, logo, ic\u00f4nes, sons, logiciels, etc.) est la propri\u00e9t\u00e9 exclusive de la soci\u00e9t\u00e9 SA ENERGO SYM ou de ses partenaires et est prot\u00e9g\u00e9 par les lois fran\u00e7aises et internationales relatives \u00e0 la propri\u00e9t\u00e9 intellectuelle."}</p>
              <p>{"Toute reproduction, repr\u00e9sentation, modification, publication, adaptation de tout ou partie des \u00e9l\u00e9ments du site, quel que soit le moyen ou le proc\u00e9d\u00e9 utilis\u00e9, est interdite, sauf autorisation \u00e9crite pr\u00e9alable de la soci\u00e9t\u00e9 SA ENERGO SYM."}</p>
              <p>{"Toute exploitation non autoris\u00e9e du site ou de l\u2019un quelconque des \u00e9l\u00e9ments qu\u2019il contient sera consid\u00e9r\u00e9e comme constitutive d\u2019une contrefa\u00e7on et poursuivie conform\u00e9ment aux dispositions des articles L.335-2 et suivants du Code de la Propri\u00e9t\u00e9 Intellectuelle."}</p>
            </Section>

            <Section title={"5. Limitation de responsabilit\u00e9"}>
              <p>{"La soci\u00e9t\u00e9 SA ENERGO SYM s\u2019efforce de fournir sur le site cloneia.fr des informations aussi pr\u00e9cises que possible. Toutefois, elle ne pourra \u00eatre tenue responsable des omissions, des inexactitudes et des carences dans la mise \u00e0 jour, qu\u2019elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations."}</p>
              <p>{"Toutes les informations indiqu\u00e9es sur le site cloneia.fr sont donn\u00e9es \u00e0 titre indicatif, et sont susceptibles d\u2019\u00e9voluer. Par ailleurs, les renseignements figurant sur le site ne sont pas exhaustifs. Ils sont donn\u00e9s sous r\u00e9serve de modifications ayant \u00e9t\u00e9 apport\u00e9es depuis leur mise en ligne."}</p>
            </Section>

            <Section title="6. Liens hypertextes">
              <p>{"Le site cloneia.fr peut contenir des liens hypertextes vers d\u2019autres sites. Cependant, SA ENERGO SYM n\u2019a pas la possibilit\u00e9 de v\u00e9rifier le contenu des sites ainsi visit\u00e9s, et n\u2019assumera en cons\u00e9quence aucune responsabilit\u00e9 de ce fait."}</p>
            </Section>

            <Section title="7. Cookies et traceurs">
              <p>{"Le site cloneia.fr utilise un syst\u00e8me d\u2019analyse de trafic propri\u00e9taire qui ne d\u00e9pose aucun cookie tiers. Un identifiant anonyme est stock\u00e9 localement dans votre navigateur (localStorage) afin de distinguer les visiteurs uniques des visiteurs r\u00e9currents. Aucune donn\u00e9e personnelle nominative n\u2019est collect\u00e9e par ce biais."}</p>
              <p>{"Pour en savoir plus sur le traitement de vos donn\u00e9es, consultez notre "}<Link to="/politique-confidentialite" className="text-[#3b82f6] hover:underline">{"Politique de confidentialit\u00e9"}</Link>.</p>
            </Section>

            <Section title="8. Droit applicable">
              <p>{"Tout litige en relation avec l\u2019utilisation du site cloneia.fr est soumis au droit fran\u00e7ais. L\u2019utilisateur reconna\u00eet la comp\u00e9tence exclusive des tribunaux comp\u00e9tents de Paris."}</p>
            </Section>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MentionsLegales;
